import styled from '@emotion/styled';

import { authColors, authRadius } from 'design-system/tokens';

const TEXT = '#3D3D3D';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.4);
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  gap: 24px;
  width: 521px;
  max-width: 100%;
  max-height: 90vh;
  padding: 24px;
  background: ${authColors.white};
  border-radius: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  align-self: stretch;
`;

export const HeaderTexts = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #000000;
`;

export const Text = styled.p`
  margin: 0;
  max-width: 320px;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #000000;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${authColors.textStrong};
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }

  &:focus-visible {
    outline: 2px solid ${authColors.brand};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const SearchBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 8px;
`;

export const SearchLabel = styled.label`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${authColors.textStrong};
`;

export const SearchField = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  gap: 8px;
  height: 48px;
  padding: 12px 32px;
  border: 1px solid ${authColors.textStrong};
  border-radius: ${authRadius.pill};

  &:focus-within {
    border-color: ${authColors.brand};
  }

  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-family: 'Mangueira', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${authColors.textStrong};

    &::placeholder {
      color: ${authColors.textMuted};
    }
  }

  svg {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    color: ${authColors.textStrong};
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 8px;
  max-height: 220px;
  overflow-y: auto;
`;

export const Option = styled.button<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  gap: 7px;
  width: 100%;
  padding: 16px;
  border: none;
  text-align: left;
  cursor: pointer;
  background: ${({ selected }) =>
    selected ? authColors.track : authColors.surface};
  border-radius: 8px;

  &:focus-visible {
    outline: 2px solid ${authColors.brand};
    outline-offset: 2px;
  }
`;

export const OptionTexts = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
`;

export const OptionTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${TEXT};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const OptionText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${TEXT};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Radio = styled.span<{ selected: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  border: 2px solid ${authColors.brand};
  border-radius: 1000px;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 1000px;
    background: ${({ selected }) =>
      selected ? authColors.brand : 'transparent'};
  }
`;

export const Empty = styled.p`
  margin: 0;
  padding: 16px;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${authColors.textMuted};
`;
